import React from "react";

function Top({ history }) {
  const handleBackButton = () => {
    history.goBack();
  };

  return (
    <>
      {process.env.REACT_APP_SYRUP_SERVER_TYPE === "LOCAL" && (
        <div className="search_top_view">
          {/* <h1>비단 금투자 서비스</h1>
          <a className="top_close_btn" onClick={handleBackButton}>
            이전
          </a> */}
        </div>
      )}
    </>
  );
}

export default Top;
